import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import { Form, Spinner } from "react-bootstrap";
import { RoundNumberUp, RoundNumberUp4 } from "../../../components/Utils/RoundNumberUp";
import Swal from "sweetalert2";
import TogoPreview from "../../../components/ClosingReports/togo/TogoPreview";
import TipsharePreview from "../../../components/ClosingReports/tipshare/TipsharePreview";

const PayToGo = () => {
  const [togoTips, setTogoTips] = useState(0);
  const [togoEmployee, setTogoEmployee] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [tipsCreated, setTipsCreated] = useState(false);
  const [equalPay, setEqualPay] = useState(false);
  const [tipsLeft, setTipsLeft] = useState(0);

  // Tipshare state variables
  const [tipshareTips, setTipshareTips] = useState(0);
  const [tipshareEmployee, setTipshareEmployee] = useState(null);
  const [tipsharePaymentDetails, setTipsharePaymentDetails] = useState(null);
  const [tipshareCreated, setTipshareCreated] = useState(false);
  const [storeDetails, setStoreDetails] = useState(null);

  // Check if current store is Casi Cielo (location_id 500 and above)
  const isCasiCielo =
    storeDetails &&
    (storeDetails.name?.toLowerCase().includes("casi cielo") ||
      Number(storeDetails.location_id) >= 500);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("storeDetails"))) {
      setStoreDetails(JSON.parse(localStorage.getItem("storeDetails")));
    }

    // Check for both old and new localStorage keys
    if (JSON.parse(localStorage.getItem("togoCalculatedPayments"))) {
      const savedTogo = JSON.parse(localStorage.getItem("togoCalculatedPayments"));
      console.log(savedTogo, "Calculatedddd");

      setTipsLeft(0);
      setTipsCreated(true);
      // Accept the wrapped shape written by an earlier build ({ togoPayments, tipsharePayments })
      setPaymentDetails(savedTogo.togoPayments || savedTogo);
    }

    if (JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments"))) {
      const combinedData = JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments"));
      console.log(combinedData, "Combined Calculatedddd");

      if (combinedData.togoPayments) {
        setTipsLeft(0);
        setTipsCreated(true);
        setPaymentDetails(combinedData.togoPayments);
      }

      if (combinedData.tipsharePayments) {
        setTipshareCreated(true);
        setTipsharePaymentDetails(combinedData.tipsharePayments);
      }
    }

    if (JSON.parse(localStorage.getItem("togoPayments"))) {
      console.log(JSON.parse(localStorage.getItem("togoPayments")));
      let togoTips = JSON.parse(localStorage.getItem("togoPayments")).togo_tips;
      let totalTogoTips = 0;
      togoTips.map((togo, index) => {
        return (totalTogoTips += togo.tips);
      });
      setTogoTips(totalTogoTips);

      setTogoEmployee(JSON.parse(localStorage.getItem("togoPayments")).togoEmployees);

      // Handle tipshare data
      if (JSON.parse(localStorage.getItem("togoPayments")).tipshare_tips) {
        let tipshareTips = JSON.parse(localStorage.getItem("togoPayments")).tipshare_tips;
        let totalTipshareTips = 0;

        // Debug: Log the tipshare_tips structure
        console.log("=== TIPSHARE DEBUG ===");
        console.log("tipshare_tips structure:", tipshareTips);
        console.log("tipshare_tips type:", typeof tipshareTips);
        console.log("tipshare_tips isArray:", Array.isArray(tipshareTips));

        if (Array.isArray(tipshareTips)) {
          console.log("tipshare_tips array length:", tipshareTips.length);
          console.log("tipshare_tips array contents:", tipshareTips);
          if (tipshareTips.length > 0) {
            console.log("tipshare_tips first item:", tipshareTips[0]);
            console.log("First item keys:", Object.keys(tipshareTips[0] || {}));
          }
        }

        const togoPaymentsData = JSON.parse(localStorage.getItem("togoPayments"));
        console.log("Full togoPayments data:", togoPaymentsData);
        console.log("tipshare_employees:", togoPaymentsData.tipshare_employees);
        console.log("tipshare_total_tips:", togoPaymentsData.tipshare_total_tips);
        console.log("tipshare_tips_legacy:", togoPaymentsData.tipshare_tips_legacy);
        console.log("======================");

        // Check if tipshare_tips is an array (new backend format)
        if (Array.isArray(tipshareTips)) {
          console.log("Processing tipshare_tips as array...");

          // New format: tipshare_tips is an array like togo_tips
          tipshareTips.forEach((tipshare, index) => {
            // Use tip_income_amount first, then fall back to declared_tips
            const amount = parseFloat(
              tipshare.tip_income_amount || tipshare.declared_tips || tipshare.tips || 0
            );
            console.log(`Tipshare ${index}:`, tipshare, `Amount: ${amount}`);
            totalTipshareTips += amount;
          });

          console.log("Calculated totalTipshareTips from array:", totalTipshareTips);

          // Use the tipshare_total_tips from backend if available and > 0, otherwise use calculated
          const backendTotal = togoPaymentsData.tipshare_total_tips;
          console.log("Backend tipshare_total_tips:", backendTotal);

          if (backendTotal && !isNaN(backendTotal) && parseFloat(backendTotal) > 0) {
            console.log("Using backend total:", backendTotal);
            setTipshareTips(parseFloat(backendTotal));
          } else if (totalTipshareTips > 0) {
            console.log("Using calculated total from individual amounts:", totalTipshareTips);
            setTipshareTips(totalTipshareTips);
          } else {
            console.warn("No valid tipshare total found");
            setTipshareTips(0);
          }

          // Convert tipshare_tips array to employee format for the form
          let tipshareEmployees = tipshareTips.map((tipshare) => ({
            employee_name: tipshare.employee_name,
            employee_number: tipshare.employee_number,
            employee_id: tipshare.employee_number,
            declared_tips: tipshare.declared_tips || 0,
            // Use tip_income_amount first, then fall back to declared_tips
            tipshare_received: parseFloat(
              tipshare.tip_income_amount || tipshare.declared_tips || tipshare.tips || 0
            ),
          }));

          console.log("Converted tipshareEmployees from array:", tipshareEmployees);
          console.log(
            "Individual tipshare amounts:",
            tipshareEmployees.map((emp) => ({
              name: emp.employee_name,
              amount: emp.tipshare_received,
            }))
          );

          // Only set tipshare employee if we have valid data
          if (tipshareEmployees.length > 0) {
            setTipshareEmployee(tipshareEmployees);
          } else {
            console.warn(
              "No valid tipshare employees found in array format, falling back to legacy processing"
            );
            // Process as legacy format below
          }
        }

        // Handle legacy format OR empty array fallback
        if (
          !Array.isArray(tipshareTips) ||
          (Array.isArray(tipshareTips) && (tipshareTips.length === 0 || !tipshareEmployee))
        ) {
          // Legacy format: tipshare_tips is a single value - use tipshare_employees for breakdown
          console.warn(
            "Processing tipshare in legacy format or as fallback. tipshareTips:",
            tipshareTips
          );

          // Try to handle as a single number value
          if (typeof tipshareTips === "number") {
            setTipshareTips(tipshareTips);
          } else if (
            tipshareTips &&
            typeof tipshareTips === "object" &&
            (tipshareTips.tipshare_tips || tipshareTips.tips)
          ) {
            setTipshareTips(tipshareTips.tipshare_tips || tipshareTips.tips);
          }

          // Create employees list for tipshare (check if separate tipshare employees exist)
          let tipshareEmployeesData = togoPaymentsData.tipshare_employees;
          let tipshareEmployees;

          if (tipshareEmployeesData) {
            // Convert tipshare_employees object to array format
            if (
              typeof tipshareEmployeesData === "object" &&
              !Array.isArray(tipshareEmployeesData)
            ) {
              // Backend sends as object with employee_id keys, convert to array
              // First, try to get employee names from togoEmployees
              const togoEmployeesData = togoPaymentsData.togoEmployees;
              const employeeNameMap = {};

              // Create a map of employee_id/number to name from togoEmployees
              if (togoEmployeesData && Array.isArray(togoEmployeesData)) {
                togoEmployeesData.forEach((emp) => {
                  employeeNameMap[emp.employee_number] = emp.employee_name;
                });
              }

              tipshareEmployees = Object.values(tipshareEmployeesData).map((emp) => ({
                employee_name: employeeNameMap[emp.employee_id] || `Employee ${emp.employee_id}`,
                employee_number: emp.employee_id,
                employee_id: emp.employee_id,
                declared_tips: 0, // Not used for tipshare
                tipshare_received: emp.declaredTips || 0, // This is actually the tipshare amount
              }));
            } else if (Array.isArray(tipshareEmployeesData)) {
              // Already in array format
              tipshareEmployees = tipshareEmployeesData;
            }
          } else {
            // Fallback to togo employees
            tipshareEmployees = togoPaymentsData.togoEmployees;
          }

          console.log("Converted tipshareEmployees from legacy format:", tipshareEmployees);
          setTipshareEmployee(tipshareEmployees);
        }
      }
    }
  }, []);

  const calculateTipAmount = (e, index, togoPaymentDetails) => {
    let tot_tips_cal = 0;
    togoPaymentDetails.map((pay, index) => {
      if (pay.tipshare_received !== undefined && !isNaN(pay.tipshare_received)) {
        tot_tips_cal += parseFloat(pay.tipshare_received);
      }

      return pay;
    });

    let new_cal_tips_left =
      parseFloat(RoundNumberUp(togoTips)) - parseFloat(RoundNumberUp(tot_tips_cal));

    if (!isNaN(new_cal_tips_left)) {
      setTipsLeft(new_cal_tips_left);
    }
  };

  const handleTogoEqualTips = () => {
    let tips = RoundNumberUp(togoTips);
    let totalEmployees = togoEmployee.length;
    let equalAmount = tips / totalEmployees;
    let newEmployeeArr = [];

    togoEmployee.map((emp, index) => {
      return newEmployeeArr.push({
        employee_name: emp.employee_name,
        employee_number: emp.employee_number,
        declared_tips: emp.declared_tips,
        tipshare_received: RoundNumberUp4(equalAmount, 4),
      });
    });

    setTogoEmployee(newEmployeeArr);
    setEqualPay(true);
    console.log([equalAmount, newEmployeeArr], "new emp");
  };

  const cancelTogoEqualTips = () => {
    let newEmployeeArr = [];

    togoEmployee.map((emp, index) => {
      return newEmployeeArr.push({
        employee_name: emp.employee_name,
        employee_number: emp.employee_number,
        declared_tips: emp.declared_tips,
        tipshare_received: 0,
      });
    });

    setTogoEmployee(newEmployeeArr);
    setEqualPay(false);
    setTipsLeft(0);
  };

  // No ToGo tips means nothing to split, so the ToGo form is hidden
  const hasTogoTips = parseFloat(RoundNumberUp(togoTips)) > 0;

  return (
    <div className="content">
      <div>
        <section>
          <h3 className="mb-4">
            TOGO
            <small id="emailHelp" className="form-text text-muted">
              Tips calculated for ToGo Employees
            </small>
          </h3>

          <div>
            <div>
              <div className="float-left">
                <div>
                  Total Tips :<b> {togoTips ? RoundNumberUp(togoTips) : ""} </b>
                </div>

                <div>
                  Tips Left : <b> {tipsLeft ? RoundNumberUp(tipsLeft) : ""} </b>
                </div>
              </div>

              {hasTogoTips && !tipsCreated && togoEmployee && togoEmployee.length > 0 && (
                <div className="float-right">
                  {!equalPay && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        handleTogoEqualTips();
                      }}
                    >
                      <span className="mdi mdi-equal"></span> Divide Equally
                    </button>
                  )}

                  {equalPay && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        cancelTogoEqualTips();
                      }}
                    >
                      <span className="mdi mdi-cancel"></span> Cancel Equal Amount
                    </button>
                  )}
                </div>
              )}
            </div>
            <div className="clearfix"></div>
            {!hasTogoTips && !tipsCreated && (
              <div className="alert alert-light mt-3" role="status">
                No ToGo tips to distribute today.
                {isCasiCielo && <strong> Please submit Tip Share below.</strong>}
              </div>
            )}
            {hasTogoTips && !tipsCreated && togoEmployee && togoEmployee.length > 0 ? (
              <div>
                <Formik
                  initialValues={{
                    togoPaymentDetails: togoEmployee ? togoEmployee : [],
                  }}
                  enableReinitialize={true}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);

                    let calculated_tip_total = 0;

                    if (values) {
                      values.togoPaymentDetails.map((tip, index) => {
                        return (calculated_tip_total += parseFloat(tip.tipshare_received));
                      });

                      if (
                        parseFloat(RoundNumberUp(togoTips)) ===
                        parseFloat(RoundNumberUp(calculated_tip_total))
                      ) {
                        setSubmitting(false);
                        setPaymentDetails(values);
                        setTipsCreated(true);
                        // Casi Cielo stores ToGo + tipshare together; other stores keep the original unwrapped shape
                        if (isCasiCielo) {
                          localStorage.setItem(
                            "togoAndTipshareCalculatedPayments",
                            JSON.stringify({
                              togoPayments: values,
                              tipsharePayments: tipsharePaymentDetails,
                            })
                          );
                        } else {
                          localStorage.setItem("togoCalculatedPayments", JSON.stringify(values));
                        }
                      } else {
                        Swal.fire({
                          title: "Error!",
                          text: `Calculated tips cannot be more or less than the amount to be distributed.`,
                          icon: "error",
                          confirmButtonText: "Ok",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setSubmitting(false);
                            console.log("Yeah");
                          }
                        });
                      }
                    }

                    console.log(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit} className="togoPaymentDetails">
                      <div className="row">
                        <div className="table-responsive col-md-12" style={{ marginTop: "30px" }}>
                          <FieldArray name="tipSummary">
                            {(fieldArrayProps) => {
                              const { form } = fieldArrayProps;
                              const { values } = form;
                              const { togoPaymentDetails } = values;

                              return (
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th style={{ width: "5%" }}> Emp Number </th>
                                      <th style={{ width: "25%" }}>Employee Name</th>
                                      <th style={{ width: "25%" }}> Declared Tips </th>
                                      <th style={{ width: "25%" }}> Tips </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {togoPaymentDetails &&
                                      togoPaymentDetails.map((tip, index) => (
                                        <tr key={tip.employee_number}>
                                          <td>
                                            <Form.Group>
                                              <Field
                                                name={`togoPaymentDetails[${index}].employee_number`}
                                                className="form-control"
                                                placeholder="Employee Number"
                                                autoComplete="off"
                                                autoCorrect="off"
                                                autoCapitalize="off"
                                                spellCheck="false"
                                                disabled={"disabled"}
                                                style={{
                                                  border: "none",
                                                  fontWeight: "bold",
                                                }}
                                              />
                                            </Form.Group>
                                          </td>
                                          <td>
                                            <Form.Group>
                                              <Field
                                                name={`togoPaymentDetails[${index}].employee_name`}
                                                className="form-control"
                                                placeholder="Employee Name"
                                                autoComplete="off"
                                                autoCorrect="off"
                                                autoCapitalize="off"
                                                spellCheck="false"
                                                disabled={"disabled"}
                                                style={{
                                                  border: "none",
                                                  fontWeight: "bold",
                                                }}
                                              />
                                            </Form.Group>
                                          </td>

                                          <td>
                                            <Form.Group>
                                              <Field
                                                name={`togoPaymentDetails[${index}].declared_tips`}
                                                className="form-control"
                                                placeholder="Declared Tips"
                                                autoComplete="off"
                                                autoCorrect="off"
                                                autoCapitalize="off"
                                                spellCheck="false"
                                                disabled={"disabled"}
                                                style={{
                                                  border: "none",
                                                  fontWeight: "bold",
                                                }}
                                              />
                                            </Form.Group>
                                          </td>

                                          <td>
                                            <Form.Group>
                                              <div className="input-group">
                                                <div className="input-group-prepend">
                                                  <span className="input-group-text">$</span>
                                                </div>

                                                <Field
                                                  name={`togoPaymentDetails[${index}].tipshare_received`}
                                                  className="form-control"
                                                  type={"text"}
                                                  placeholder="Tips"
                                                  autoComplete="off"
                                                  autoCorrect="off"
                                                  autoCapitalize="off"
                                                  spellCheck="false"
                                                  disabled={isSubmitting || equalPay}
                                                  defaultValue={
                                                    tip.tipshare_received
                                                      ? parseFloat(
                                                          RoundNumberUp(tip.tipshare_received)
                                                        )
                                                      : ""
                                                  }
                                                  onBlur={(e) => {
                                                    calculateTipAmount(
                                                      e,
                                                      index,
                                                      togoPaymentDetails
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </Form.Group>
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              );
                            }}
                          </FieldArray>
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <div className="col-md-12">
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="btn btn-primary mr-2"
                          >
                            Submit &nbsp;&nbsp;
                            {isSubmitting ? <Spinner animation="border" size="sm" /> : ""}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            ) : (
              ""
            )}

            {tipsCreated && (
              <div>
                <div className="row">
                  <TogoPreview paymentDetails={paymentDetails} />
                </div>

                <div className="row" style={{ marginTop: "20px", marginBottom: "20px" }}>
                  <div className="col-md-12">
                    <button
                      type="submit"
                      className="btn btn-inverse-dark mr-2"
                      onClick={() => {
                        const storageKey = isCasiCielo
                          ? "togoAndTipshareCalculatedPayments"
                          : "togoCalculatedPayments";
                        if (isCasiCielo) {
                          // Remove only togo part from combined storage
                          const combinedData = JSON.parse(localStorage.getItem(storageKey)) || {};
                          if (combinedData.tipsharePayments) {
                            localStorage.setItem(
                              storageKey,
                              JSON.stringify({
                                tipsharePayments: combinedData.tipsharePayments,
                              })
                            );
                          } else {
                            localStorage.removeItem(storageKey);
                          }
                        } else {
                          localStorage.removeItem(storageKey);
                        }
                        setTipsCreated(false);
                      }}
                    >
                      Cancel &nbsp;&nbsp;
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* Tipshare Tips Section - Only for Casi Cielo */}
        {isCasiCielo && (
          <section style={{ marginTop: "50px" }}>
            <h3 className="mb-4">
              TIPSHARE TIPS
              <small id="emailHelp" className="form-text text-muted">
                Tipshare tips calculated for ToGo Employees (Casi Cielo only)
              </small>
            </h3>

            <div>
              <div>
                <div className="float-left">
                  <div>
                    Total Tipshare Tips :<b> {tipshareTips ? RoundNumberUp(tipshareTips) : ""} </b>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>

              {!tipshareCreated && tipshareEmployee && tipshareEmployee.length > 0 ? (
                <div>
                  <Formik
                    initialValues={{
                      tipsharePaymentDetails: tipshareEmployee ? tipshareEmployee : [],
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, { setSubmitting }) => {
                      setSubmitting(true);

                      let calculated_tip_total = 0;

                      if (values) {
                        values.tipsharePaymentDetails.map((tip, index) => {
                          return (calculated_tip_total += parseFloat(tip.tipshare_received));
                        });

                        // Debug the validation comparison
                        console.log("=== TIPSHARE VALIDATION DEBUG ===");
                        console.log("Total from backend (tipshareTips):", tipshareTips);
                        console.log("Calculated from individual amounts:", calculated_tip_total);
                        console.log(
                          "Rounded backend total:",
                          parseFloat(RoundNumberUp(tipshareTips))
                        );
                        console.log(
                          "Rounded calculated total:",
                          parseFloat(RoundNumberUp(calculated_tip_total))
                        );
                        console.log(
                          "Individual tipshare amounts:",
                          values.tipsharePaymentDetails.map((tip) => ({
                            employee: tip.employee_name,
                            amount: tip.tipshare_received,
                          }))
                        );

                        // Check if backend provided the total directly
                        const togoPaymentsData = JSON.parse(localStorage.getItem("togoPayments"));
                        const backendTipshareTotal = togoPaymentsData?.tipshare_total_tips;
                        console.log("Backend tipshare_total_tips:", backendTipshareTotal);

                        // Use backend calculated total if available, otherwise use the tipshareTips state
                        const totalToCompare = backendTipshareTotal
                          ? parseFloat(backendTipshareTotal)
                          : tipshareTips;
                        console.log("Total to compare against:", totalToCompare);
                        console.log("===============================");

                        if (
                          parseFloat(RoundNumberUp(totalToCompare)) ===
                          parseFloat(RoundNumberUp(calculated_tip_total))
                        ) {
                          setSubmitting(false);
                          setTipsharePaymentDetails(values);
                          setTipshareCreated(true);
                          // Store in combined localStorage
                          const existingData =
                            JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments")) ||
                            {};
                          localStorage.setItem(
                            "togoAndTipshareCalculatedPayments",
                            JSON.stringify({
                              ...existingData,
                              tipsharePayments: values,
                            })
                          );
                        } else {
                          Swal.fire({
                            title: "Error!",
                            text: `Calculated tipshare tips (${RoundNumberUp(
                              calculated_tip_total
                            )}) cannot be more or less than the amount to be distributed (${RoundNumberUp(
                              totalToCompare
                            )}).`,
                            icon: "error",
                            confirmButtonText: "Ok",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setSubmitting(false);
                              console.log("Yeah");
                            }
                          });
                        }
                      }

                      console.log(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue,
                    }) => (
                      <form onSubmit={handleSubmit} className="tipsharePaymentDetails">
                        <div className="row">
                          <div className="table-responsive col-md-12" style={{ marginTop: "30px" }}>
                            <FieldArray name="tipSummary">
                              {(fieldArrayProps) => {
                                const { form } = fieldArrayProps;
                                const { values } = form;
                                const { tipsharePaymentDetails } = values;

                                return (
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "15%" }}> Emp Number </th>
                                        <th style={{ width: "45%" }}>Employee Name</th>
                                        <th style={{ width: "40%" }}> Tipshare Tips </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {tipsharePaymentDetails &&
                                        tipsharePaymentDetails.map((tip, index) => (
                                          <tr key={tip.employee_number}>
                                            <td>
                                              <Form.Group>
                                                <Field
                                                  name={`tipsharePaymentDetails[${index}].employee_number`}
                                                  className="form-control"
                                                  placeholder="Employee Number"
                                                  autoComplete="off"
                                                  autoCorrect="off"
                                                  autoCapitalize="off"
                                                  spellCheck="false"
                                                  disabled={"disabled"}
                                                  style={{
                                                    border: "none",
                                                    fontWeight: "bold",
                                                  }}
                                                />
                                              </Form.Group>
                                            </td>
                                            <td>
                                              <Form.Group>
                                                <Field
                                                  name={`tipsharePaymentDetails[${index}].employee_name`}
                                                  className="form-control"
                                                  placeholder="Employee Name"
                                                  autoComplete="off"
                                                  autoCorrect="off"
                                                  autoCapitalize="off"
                                                  spellCheck="false"
                                                  disabled={"disabled"}
                                                  style={{
                                                    border: "none",
                                                    fontWeight: "bold",
                                                  }}
                                                />
                                              </Form.Group>
                                            </td>

                                            <td>
                                              <Form.Group>
                                                <div className="input-group">
                                                  <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                  </div>

                                                  <Field
                                                    name={`tipsharePaymentDetails[${index}].tipshare_received`}
                                                    className="form-control"
                                                    type={"text"}
                                                    placeholder="Tipshare Tips"
                                                    autoComplete="off"
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    spellCheck="false"
                                                    disabled={"disabled"}
                                                    style={{
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    defaultValue={
                                                      tip.tipshare_received
                                                        ? parseFloat(
                                                            RoundNumberUp(tip.tipshare_received)
                                                          )
                                                        : ""
                                                    }
                                                  />
                                                </div>
                                              </Form.Group>
                                            </td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                );
                              }}
                            </FieldArray>
                          </div>
                        </div>

                        <div className="row" style={{ marginTop: "20px", marginBottom: "20px" }}>
                          <div className="col-md-12">
                            <button
                              type="submit"
                              disabled={isSubmitting}
                              className="btn btn-primary mr-2"
                            >
                              Submit Tipshare &nbsp;&nbsp;
                              {isSubmitting ? <Spinner animation="border" size="sm" /> : ""}
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              ) : (
                ""
              )}

              {tipshareCreated && (
                <div>
                  <div className="row">
                    <TipsharePreview paymentDetails={tipsharePaymentDetails} />
                  </div>

                  <div className="row" style={{ marginTop: "20px", marginBottom: "20px" }}>
                    <div className="col-md-12">
                      <button
                        type="submit"
                        className="btn btn-inverse-dark mr-2"
                        onClick={() => {
                          // Remove only tipshare part from combined storage
                          const combinedData =
                            JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments")) ||
                            {};
                          if (combinedData.togoPayments) {
                            localStorage.setItem(
                              "togoAndTipshareCalculatedPayments",
                              JSON.stringify({
                                togoPayments: combinedData.togoPayments,
                              })
                            );
                          } else {
                            localStorage.removeItem("togoAndTipshareCalculatedPayments");
                          }
                          setTipshareCreated(false);
                        }}
                      >
                        Cancel Tipshare &nbsp;&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default PayToGo;
